import React from "react";

import { wrap } from "./RydTestbedWrap";
import { TrackColor } from "../render/trackColor";
import { TrackColorPicker } from "../components/pickers/TrackColorPicker";

export function ColorTableTestbed() {

    const steps = 5;
    const brightnessSteps = 4;

    const colors = TrackColor.generateColorTable(
        '#000000', // minColor
        ['#FF0000', '#FFFF00', '#FF7E00', '#00FF00', '#007EFF', '#00FFFF', '#0000FF'], // maxColor
        steps,
        brightnessSteps
    );

    return wrap(<>
        {/* Add your testbed components here */}
        <h1>ColorTable Testbed</h1>
        <div className="color-table" style={{ display: 'grid', gridTemplateColumns: `repeat(${steps}, 1fr)`, gap: '1px' }}>
            {colors.map((color, index) => (
                <div key={index} className="color-box" style={{ backgroundColor: color }}>
                    {color}
                </div>
            ))}
        </div>

        <TrackColorPicker
            onColorSelect={(color) => console.log('Selected color:', color)}
            steps={steps}
            brightnessSteps={brightnessSteps}
            minColor="#000000"
            maxColors={['#FF0000', '#FFFF00', '#FF7E00', '#00FF00', '#007EFF', '#00FFFF', '#0000FF']}
        />
    </>);
}